import { FC } from 'react';
import { MBox, MText } from '../../../../../components/Monetize';

export const EmptyRegionPlaceholder: FC<{
  label: string;
  onClick: () => void;
}> = ({ label, onClick }) => (
  <MBox
    role="button"
    tabIndex={0}
    cursor="pointer"
    border="1.5px dashed"
    borderColor="tGray.lightGray"
    borderRadius="md"
    py={4}
    mb={2}
    textAlign="center"
    onClick={onClick}
    onKeyDown={(event) => {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        onClick();
      }
    }}
    _hover={{ bg: 'bg.subtle' }}
    _focusVisible={{ boxShadow: 'focus', outline: 'none' }}
  >
    <MText fontSize="sm" color="tGray.darkPurple">
      {label}
    </MText>
  </MBox>
);

// Absolutely positioned over the whole zone (rows + placeholder) instead of
// appending an extra row, so dragging over a populated zone doesn't shift
// the list. Requires the zone wrapper to be position="relative".
export const DropZoneOverlay: FC = () => (
  <MBox position="absolute" inset={0} pointerEvents="none">
    <MBox
      position="absolute"
      inset={0}
      border="1.5px dashed"
      borderColor="border.accent"
      bg="bg.selected"
      opacity={0.5}
      borderRadius="md"
    />
    <MBox
      position="relative"
      h="100%"
      display="flex"
      alignItems="center"
      justifyContent="center"
    ></MBox>
  </MBox>
);
